import { render, staticRenderFns } from "./TicketType.vue?vue&type=template&id=0cd0320e&"
import script from "./TicketType.vue?vue&type=script&lang=js&"
export * from "./TicketType.vue?vue&type=script&lang=js&"
import style0 from "./TicketType.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports